import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { HttpResponse } from "@angular/common/http";
import { ProviderService } from "../provider.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { OrganizationService } from '../../organization-management/organization.service';
// import Swal from "sweetalert2";
@Component({
  selector: 'app-add-provider',
  templateUrl: './add-provider.component.html',
  styleUrls: ['./add-provider.component.css']
})
export class AddProviderComponent implements OnInit {

  providerForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  organizationList = []

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: ProviderService,
    private OrganizationService:OrganizationService
  ) { }

  ngOnInit() {
    this.initialiseForms();
    this.providerForm.reset();
    this.getOrgs();
  }

  getOrgs() {
    let query = ""
    this.OrganizationService.getOrganizationsApi(query).subscribe(res => {
      this.spinner.show();
      if ((res["status"] == "Success")) {
        this.organizationList = res.data.organizationList;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  } 
  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  onlyNumbersandSpecialChar(evt) {
    var e = window.event || evt;
    var charCode = e.which || e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57 || charCode > 107 || charCode > 219 ||          charCode > 221) && charCode != 40 && charCode != 32 && charCode != 41 && (charCode < 43 || charCode > 46)) {
        if (window.event) //IE
            window.event.returnValue = false;
        else //Firefox
            e.preventDefault();
    }
    return true;

   }


  initialiseForms() {
    this.providerForm = this.fb.group({
      name: ["", [Validators.required]],
      password: ["", [Validators.required]],
      mobile: ["", [Validators.required]],
      mobileFormat: ["", [Validators.required]],
      role: ["", [Validators.required]],
      organizationId:["", [Validators.required]],
      email:["", [Validators.required, Validators.pattern(this.emailPattern)]],
      address: [""],
      link: [""],

    });
  }


  Addplan() {
    this.formSubmitted = true;
    if (this.providerForm.valid) {
      let request = this.providerForm.value;
       request['mobile'] = request['mobile'].toString();
       delete request['mobileFormat']
       if (request['address'] == '' || request['address'] == null ) {
         delete request['address']
       }
       if (request['organizationId'] == '' || request['organizationId'] == null ) {
         request['organizationId'] = ""
      }
      if (request['link'] == '' || request['link'] == null ) {
        request['link'] = ""
     }

      
      this.PlanService.saveplan(request).subscribe(data => {
        if ((data["status"] = "Success")) {
          Swal.fire("Success", "Provider Added successfully!", "success");
          this.router.navigate(["/main/provider/view"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    
    }




  }

  checkRole() {
    // if(this.providerForm.controls.role.value == 'biller' || this.providerForm.controls.role.value == 'providerAdmin') {
    //   this.providerForm.controls.organizationId.setValidators([Validators.required])
    //   this.providerForm.controls.organizationId.updateValueAndValidity();
    // } else {
    //   this.providerForm.controls.organizationId.clearValidators()
    // }
  }

  cancel() {
    this.router.navigate(["/main/provider/view"]);
  }
  mobileNumber=""
  _mobileFormat() {
    var phone = this.providerForm.value.mobileFormat.toString();
    phone = phone.replace('(', '').replace(')', '').replace(new RegExp('-', 'g'), '').replace(new RegExp(' ', 'g'), '')
    this.formatMobileNumber(phone)
  }

  formatMobileNumber(phone: any) {
    var str = phone.toString();
    var strFormat;
    if (this.mobileNumber !== str) {
      this.mobileNumber = str;
      if (str.length <= 3)
        strFormat = '(' + str.substr(0, 3) + ')'
      if (str.length > 3 && str.length <= 6)
        strFormat = '(' + str.substr(0, 3) + ')' + '' + str.substr(3, 3);
      if (str.length > 6)
        strFormat = '(' + str.substr(0, 3) + ')' + ' ' + str.substr(3, 3) + '-' + str.substr(6, 4);
      this.providerForm.controls['mobile'].setValue(str);
      this.providerForm.controls['mobileFormat'].setValue(strFormat);
    }
  }
}


